import $ from 'jquery';

import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
import HandheldMenu from './components/handheld-menu';
import DesktopMenu from './components/menu-desktop';
import HomeSlider from './components/home-slider';
import CookiesConsent from './components/cookies-consent';
import DeviceManager from './utils/device-manager';
import NewsSlider from './components/news-slider';
import PartnersSlider from './components/partners-slider';
import Timeline from './components/timeline';
import ScrollInView from "./components/scroll-in-view";

$(function () {
	const state = {
		gmapDependentComponentsInstanciated: false,
	};
	const bootstrapApp = () => {
		const $html = $('html');

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass('touch');

			if (DeviceManager.isIos()) {
				$html.addClass('ios');
			}
		} else {
			$html.addClass('no-touch');
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass('ie11');
		} else if (DeviceManager.isEdge()) {
			$html.addClass('edge');
		}
	};

	const instanciateRegularComponents = async () => {
		// General components
		const langSelector = new LangSelector($('.language-selector'));
		const siteHeader = new SiteHeader($('.site-header'), 20);
		// const handheldMenu = new HandheldMenu();

		// Scroll in view component
        const $scrollInViewElements = $(".scroll-in-view");
        if ($scrollInViewElements.length) {
            $scrollInViewElements.imagesLoaded(function () {
                const scrollInView = new ScrollInView($scrollInViewElements);
                window.scrollInView = scrollInView;
            });
        }

		// Slides section slider
		const $homeSlides = $('.slider');
		if ($homeSlides.length) {
			$homeSlides.each(function (index, el) {
				let homeSlides = new HomeSlider($(el));
			});
		}

		// News section slider
		const $newsSlides = $('.news-slider');
		if ($newsSlides.length) {
			$newsSlides.each(function (index, el) {
				let newsSlides = new NewsSlider($(el));
			});
		}

		// Partners slider
		const $partnersSlides = $('.partenaires__list');
		if ($partnersSlides.length) {
			$partnersSlides.each(function (index, el) {
				let partnersSlides = new PartnersSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== 'undefined' && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = '';
			switch(document.documentElement.lang) {
				case 'fr-FR':
				tarteaucitronLang = 'fr';
				break;
				case 'en-US':
				tarteaucitronLang = 'en';
				break;
				case 'de-DE':
				tarteaucitronLang = 'de';
				break;
				default:
					tarteaucitronLang = 'fr';
			}

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}
	};

	bootstrapApp();
	instanciateRegularComponents();
});
